import { render, staticRenderFns } from "./SystemBackstageData.vue?vue&type=template&id=206d8471&scoped=true"
import script from "./SystemBackstageData.vue?vue&type=script&lang=js"
export * from "./SystemBackstageData.vue?vue&type=script&lang=js"
import style0 from "./SystemBackstageData.vue?vue&type=style&index=0&id=206d8471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d8471",
  null
  
)

export default component.exports